import React from 'react';

import Header from './Header';
import FooterComponent from './Footer';
import {
  Wrapper,
  Head,
  Container,
  CurvedCanvas,
  Background,
  ContentWrapper,
} from './styles';
import { useSelector } from 'react-redux';

function Layout({ children }: any) {
  const { signed, page } = useSelector((state: ApplicationState) => {
    return {
      signed: state.auth.signed,
      page: state.auth.page,
    };
  });

  return (
    <>
      <Wrapper isAuth={signed} page={page}>
        <Head>
          <Header />
        </Head>
        <ContentWrapper>
          <Container isAuth={signed} page={page}>
            {children}
          </Container>
          <Background>
            <CurvedCanvas
              style={{ marginBottom: '-40px', alignSelf: 'flex-end' }}
            ></CurvedCanvas>
            <CurvedCanvas
              style={{ transform: 'rotate(180deg)', marginTop: '-40px' }}
            ></CurvedCanvas>
          </Background>
        </ContentWrapper>
        <FooterComponent />
      </Wrapper>
    </>
  );
}

export default Layout;
